module.exports = __webpack_public_path__ + "img/کارت-ویزیت-کتان-پلاستیک.8daf40d5.png";